'use strict';

var numFlightsFilterConfig = {
    time: 2,
    timeBudget: 2,
    flightDuration: 2,
    timeRanges: 2,
};

module.exports = function(filterType, tripType, numFlights) {
    var numLegs;
    if (tripType === 'roundTrip') {
        numLegs = numFlightsFilterConfig[Odigeo._.camelCase(filterType)] || 1;
    }
    return numLegs || numFlights;
};
